// src/services/authService.js
import { supabase } from "../lib/supabase";
const params = new URLSearchParams(window.location.search);
const referralCode = params.get("ref"); // o "code"

export const authService = {
  // ✅ SIGN UP LIMPIO (SIN CONFIRMACIÓN)
  async signUp(email, password, fullName, phone, role = "advisor", referralCode=null) {
    try {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            full_name: fullName || null,
            phone: phone || null,
            role,
          },
        },
      });

      if (error) {
        // Mensajes amigables
        const msg = (error.message || "").toLowerCase();

        if (msg.includes("already") || msg.includes("registered")) {
          return {
            data: null,
            error: new Error("Este correo ya está registrado. Por favor, inicia sesión."),
            requiresConfirmation: false,
            message: "",
          };
        }

        return {
          data: null,
          error,
          requiresConfirmation: false,
          message: "",
        };
      }

      // Con confirmación OFF: debe existir session
      const requiresConfirmation = !!data?.user && !data?.session;

      return {
        data,
        error: null,
        requiresConfirmation, // debería ser false si está OFF
        message: "Registro exitoso.",
      };
    } catch (error) {
      console.error("SignUp error:", error);
      return { data: null, error, requiresConfirmation: false, message: "" };
    }
  },

  async signIn(email, password) {
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) {
        const msg = error?.message || "";

        if (msg.includes("Invalid login credentials")) {
          throw new Error("Correo o contraseña incorrectos");
        } else if (msg.includes("Email not confirmed")) {
          // En tu caso, no debería pasar si confirmación está OFF
          throw new Error("Tu correo no está confirmado (revisa configuración de Supabase).");
        } else if (msg.includes("Email link is invalid")) {
          throw new Error("El enlace de confirmación expiró. Solicita uno nuevo.");
        }
        throw error;
      }

      return { data, error: null };
    } catch (error) {
      console.error("SignIn error:", error);
      return { data: null, error };
    }
  },

  async signOut() {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      return { error: null };
    } catch (error) {
      console.error("SignOut error:", error);
      return { error };
    }
  },

  async getCurrentUser() {
    try {
      const {
        data: { user },
        error,
      } = await supabase.auth.getUser();

      if (error) throw error;
      return { user, error: null };
    } catch (error) {
      console.error("GetCurrentUser error:", error);
      return { user: null, error };
    }
  },

  async getUserProfile(userId) {
    try {
      const { data, error } = await supabase
        .from("user_profiles")
        .select("*")
        .eq("id", userId)
        .single();

      if (error) {
        // Si el perfil aún no existe
        if (error?.code === "PGRST116") {
          return { data: null, error: null };
        }
        throw error;
      }

      return { data, error: null };
    } catch (error) {
      console.error("GetUserProfile error:", error);
      return { data: null, error };
    }
  },

  async updateProfile(userId, updates) {
    try {
      const { data, error } = await supabase
        .from("user_profiles")
        .update(updates)
        .eq("id", userId)
        .select()
        .single();

      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error("UpdateProfile error:", error);
      return { data: null, error };
    }
  },

  async waitForProfile(userId, maxAttempts = 50) {
    // Espera aprox 5 segundos (50 * 100ms)
    for (let i = 0; i < maxAttempts; i++) {
      const { data } = await this.getUserProfile(userId);
      if (data) return data;
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    return null;
  },
};
